import { createFileRoute } from "@tanstack/react-router";
import { HubShell, Section, PortalTable, FaqAccordion, hubHead } from "@/components/work-hubs/HubShell";

export const Route = createFileRoute("/remote-jobs/portals")({
  head: () =>
    hubHead(
      "/remote-jobs/portals",
      "Remote Job Portals — ModSquad, TELUS, Outlier, Welocalize | DrHint",
      "Directory of established remote companies hiring for chat support, moderation, AI training and localisation — with official apply links.",
    ),
  component: Page,
});

const ROWS = [
  { name: "ModSquad", url: "https://modsquad.com/join-the-squad/", type: "Chat support, community moderation", pay: "Varies by project (hourly)", regions: "Project-dependent, many countries", badge: "Freelance network" },
  { name: "TELUS Digital (TELUS International)", url: "https://www.telusinternational.ai/cmp", type: "Search/ad rating, data annotation", pay: "Hourly, set per country", regions: "Many countries; language-based", badge: "Part-time rater" },
  { name: "Outlier", url: "https://outlier.ai/", type: "AI training, writing, coding review", pay: "Hourly/task, higher for experts", regions: "Selected countries", badge: "Project-based" },
  { name: "Welocalize", url: "https://www.welocalize.com/careers/", type: "Localisation, data & rating tasks", pay: "Hourly or per word", regions: "Worldwide, language-based", badge: "Language roles" },
];

function Page() {
  return (
    <HubShell
      crumbs={[{ label: "Home", to: "/" }, { label: "Remote Jobs", to: "/remote-jobs" }, { label: "Portals" }]}
      step={3}
      eyebrow="Remote Hub"
      title="Active Direct-Apply Remote Portals"
      intro="These are long-running companies that hire remote workers for non-phone tasks. Links go to their official sites — never apply through a third-party WhatsApp or Telegram 'agent'."
      back={{ to: "/remote-jobs/requirements", label: "Back to checklist" }}
    >
      <Section title="Directory">
        <PortalTable rows={ROWS} />
        <p className="text-xs">Pay is not shown as a fixed number because it changes by country, language and project. You will see the exact rate before you accept any task.</p>
      </Section>

      <Section title="Frequently asked questions">
        <FaqAccordion faqs={[
          { q: "Do these companies charge a joining fee?", a: "No. None of them charge to apply. If someone asks for money in their name, it is a scam." },
          { q: "Can I apply from Pakistan or India?", a: "Some projects accept applicants from South Asia, others do not. Availability changes often, so check the country list on each official application form." },
          { q: "How long until I get work?", a: "From a few days to several weeks. Many platforms put new applicants on a waiting list until a project opens." },
          { q: "Can I do this on my phone?", a: "Rarely. Most tasks and all qualification tests require a computer." },
          { q: "Is this full-time income?", a: "Usually not at the start. Treat it as part-time or flexible work until you have a steady project." },
        ]} />
      </Section>
    </HubShell>
  );
}
